import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEditingProps, } from 'console/device-settings/z3k/components/utils/unpack-props';
import { memo, useContext, useMemo } from 'react';
import { MaterialReadOnly } from 'console/shared/components/fields';
import { SettingContainer } from '../../material-utils/settings-card/container';
import { SettingFullRow } from '../../material-utils/settings-card/full-row';
import { MultipleSelectionTable, } from '../../material-utils/multiple-selection-table/multiple-selection';
import { Z3KSettingsEditor } from '../../../provider/types';
import { reactionsAndGuardZonesOptions } from '../../utils/z3k-selectors';
import { Control } from 'console/shared/components/fields/control';
import { TextInputWrapper } from 'console/shared/components/fields/text';
export const FobButtonComponent = memo(function FobButtonComponent(props) {
    const { config } = useContext(Z3KSettingsEditor);
    const nameEditingProps = useEditingProps(props.value.id, 'fob_buttons', 'name');
    const reactions_and_guard_zones_options = reactionsAndGuardZonesOptions(config);
    const multipleSelectionTableOptions = useMemo(() => {
        return [
            {
                title: 'Список действий при нажатии кнопки',
                help_id: 'fob_buttons_press_button_actions',
                options: reactions_and_guard_zones_options,
                z3k_field: 'commands',
            },
        ];
    }, [props.value.id]);
    return (_jsxs(SettingContainer, { alignItems: "flex-end", children: [_jsx(Control, { label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", field: TextInputWrapper, help_id: "fob_buttons_name", ...nameEditingProps }), _jsx(MaterialReadOnly, { alignTop: false, label: "\u0423\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439 ID", value: props.value.unique_id, help_id: null, show_copy: true }), _jsx(SettingFullRow, { children: _jsx(MultipleSelectionTable, { elements: multipleSelectionTableOptions, z3k_name: 'fob_buttons', item_id: props.value.id, notification: false }) })] }));
});
